import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Welcome.css';

const mapStateToProps = state => ({
  events: state.invitee.events,
});

const mapDispatchToProps = dispatch => ({});

const OnlyNY = () => (
  <div>
    <p>
      Welcome to our wedding website! We're really looking forward to spending
      our special day with special you!
    </p>
    <p>
      This site is your source for information about the event including
      location, time, itinerary, accommodations, and travel details. In the
      coming months we will add the music requests and food allergy sections as
      well as an Instagram photo feed.
    </p>
    <p>
      We will be adding more information to this site up until the big day so
      come back again later if you have unanswered questions. Be sure to RSVP!
    </p>
  </div>
);

const IncludingParksville = () => (
  <div className="welcome">
    <p>Dear Friends and Family,</p>
    <p>
      We are excited to share with you in the celebration of our upcoming
      wedding pre-ception on Sunday June 30th.
    </p>
    <p>
      This lovely celebration will start at 4:30 and be held at Pacific Shores
      Resort in Parksville, BC.{' '}
      <a href="https://pacificshoresbc.com">pacificshoresbc.com</a>
    </p>
    <p>
      If you would like to stay at the resort we have arranged rooms at a
      special rate. You can call the resort and let them know you are with the
      Dorsay Wedding. The special rate is for a 2 night stay (Saturday and
      Sunday).
    </p>
    <p>
      A cocktail hour featuring lawn games will begin at 4:30 at the water's
      edge which will allow us to enjoy the amazing setting. Please consider
      footwear that will be comfortable on the grass. As well, bring a sweater
      for the evening. Dinner will be served at 6:00 and dancing will commence
      later in the evening.
    </p>
    <p>
      The attire is Smart Casual; Polished yet relaxed. If the weather does not
      cooperate, we will move the event indoors. Thank you to everyone who has
      already RSVP’d. If you haven't yet confirmed you are coming please RSVP
      down below or contact us to let us know if you're coming.
    </p>
    <p>
      If you are having any difficulties, please contact us and we will help.
    </p>
    <p>
      The website has been updated with the registry, venue, and accommodation
      information.
    </p>
    <p>
      If you would like to chat with Steve or Roné, please feel free to give
      them a call at <a href="tel:250-947-0308">250-947-0308</a> or email at{' '}
      <a href="mailto:dorsay@shaw.ca">dorsay@shaw.ca</a>.
    </p>
    <p>Thank you and we are looking forward to celebrating together!</p>
    <p />
  </div>
);

class Welcome extends Component {
  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
  }

  render() {
    const containsCA = Object.keys(this.props.events).includes('ca');
    return (
      <section id={this.sectionId}>
        <h1>Welcome</h1>
        {containsCA ? IncludingParksville() : OnlyNY()}
      </section>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome.js